<template>
  <section>
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filtersForm">
          <el-form-item label="产品名称：">
            <el-input v-model="filtersForm.prodname" size="small" style="width:150px;" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户名称：">
            <el-input v-model="filtersForm.custname" size="small" style="width:150px;" clearable></el-input>
          </el-form-item>
          <el-form-item label="失效日期：">
            <el-date-picker v-model="filtersForm.start_end_date" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              size="small" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="注册码：">
            <el-input v-model="filtersForm.auth_code" size="small" style="width:300px;" clearable></el-input>
          </el-form-item>
          <el-form-item label="IMEI号：">
            <el-input v-model="filtersForm.device_serial" size="small" style="width:200px;" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getAuthorityList(1)" size="small">查询</el-button>
            <el-button type="primary" size="small" @click="handleAdd">新增注册码</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!--  -->
    <el-table :data="tableData" stripe border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="#" width="50" align="center">
      </el-table-column>
      <el-table-column prop="prod_name" label="产品名称" align="center">
      </el-table-column>
      <el-table-column prop="cust_name" label="客户名称" align="center">
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.create_time.split(" ")[0] }}
        </template>
      </el-table-column>
      <el-table-column prop="expire_time" label="失效时间" width="100" align="center">
      </el-table-column>
      <el-table-column prop="auth_code" label="注册码" width="300" align="center">
      </el-table-column>
      <el-table-column prop="code_status" label="状态" min-width="50" align="center">
        <template slot-scope="scope">
          {{ scope.row.code_status === 1 ? '有效' : '失效' }}
        </template>
      </el-table-column>
      <el-table-column prop="device_serial" label="IMEI" align="center" width="150">
        <template slot-scope="scope">
          <p style="color:#66b1ff;cursor:pointer" @click="showDeviceInfo(scope.row.device_serial)">
            {{ scope.row.device_serial }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="auth_comment" label="备注" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button @click="handleUpdate(scope.row)" type="text" size="small">编辑</el-button>
          <el-button type="text" size="small" @click="handleUnBind(scope.row.auth_code)">解绑</el-button>
          <el-button @click="handleDelete(scope.row.auth_code)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  -->
    <el-pagination background layout="prev, pager, next" :page-size="filtersForm.pagesize" :total="total"
      @current-change="getAuthorityList" style="text-align:right;margin-top:10px;">
    </el-pagination>
    <!--  -->
    <el-dialog title="新增注册码" :visible.sync="registerDialogVisible" width="30%" v-loading="handleLoading"
      :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
      <el-form label-width="85px" :model="registerForm" ref="registerForm" :rules="registerFormRules">
        <el-form-item label="产品" prop="prod_id">
          <el-select filterable v-model="registerForm.prod_id" placeholder="请选择" :disabled="formType == 'edit'">
            <el-option v-for="item in products" :key="item.prod_id" :label="item.prod_name" :value="item.prod_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户(父)" prop="cust_id" :disabled="formType == 'edit'">
          <el-select filterable v-model="registerForm.cust_id" @change="cusIdChange" placeholder="请选择"
            :disabled="formType == 'edit'">
            <el-option v-for="item in customers" :key="item.cust_id" :label="item.cust_name" :value="item.cust_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="subCustomers.length > 0" label="子客户" prop="cust_id">
          <el-select filterable v-model="sub_cust_id" placeholder="请选择" :disabled="formType == 'edit'">
            <el-option v-for="item in subCustomers" :key="item.cust_id" :label="item.cust_name" :value="item.cust_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="失效日期" prop="expire_time">
          <el-date-picker v-model="registerForm.expire_time" type="date" placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="数量" prop="amount" v-if="formType == 'add'">
          <el-input-number v-model="registerForm.amount" :min="1" :max="100" label="描述文字"></el-input-number>
          <!-- <el-input v-model="registerForm.amount"></el-input> -->
        </el-form-item>
        <el-form-item label="备注" prop="auth_comment">
          <el-input v-model="registerForm.auth_comment" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetRegisterForm" v-loading="handleLoading">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" v-loading="handleLoading">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设备信息弹窗 -->
    <el-dialog title="设备注册信息" :visible.sync="deviceModal" width="70%">
      <el-row style="transform: translateY(-80%);">
        <el-col :span="10"><b>IMEI号：</b>{{ deviceInfo.device_serial }}</el-col>
        <el-col :span="10"><b>设备型号：</b>{{ deviceInfo.device_type }}</el-col>
      </el-row>
      <el-collapse accordion>
        <el-collapse-item v-for="item in deviceInfoList" :key="item.auth_code">
          <template slot="title">
            {{ item.cust_name }}（产品名称：{{ item.prod_name }}）V{{ item.prod_version }}
          </template>
          <div>
            <el-row :gutter="20">
              <el-col :span="3" :offset="1" class="info-title">使 用 者 ：</el-col>
              <el-col :span="7">{{ item.device_user || "--" }}</el-col>
              <el-col :span="4" class="info-title">使用者手机号：</el-col>
              <el-col :span="6">{{ item.device_tele_num || "--" }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="3" :offset="1" class="info-title">客户名称：</el-col>
              <el-col :span="7">{{ item.cust_name }}</el-col>
              <el-col :span="4" class="info-title">产 品 名 称&nbsp;&nbsp;&nbsp;：</el-col>
              <el-col :span="6">{{ item.prod_name }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="3" :offset="1" class="info-title">产品包名：</el-col>
              <el-col :span="7">{{ item.prod_package }}</el-col>
              <el-col :span="4" class="info-title">产 品 版 本&nbsp;&nbsp;&nbsp;：</el-col>
              <el-col :span="6">V {{ item.prod_version }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="3" :offset="1" class="info-title">注 册 码 ：</el-col>
              <el-col :span="7">{{ item.auth_code }}</el-col>
              <el-col :span="4" class="info-title">备 注 信 息&nbsp;&nbsp;&nbsp;：</el-col>
              <el-col :span="6">{{ item.auth_comment }}</el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="3" :offset="1" class="info-title">创建时间：</el-col>
              <el-col :span="9">{{ item.create_time }}</el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </section>
</template>

<script>
import {
  getAuthorityList,
  addAuthority,
  updateAuthority,
  deleteAuthority,
  getCustProdcut,
  unbindAuthority,
  getDeviceInfo
} from "../../api";
export default {
  data() {
    return {
      deviceModal: false, // 设备信息弹窗
      deviceInfo: {},
      deviceInfoList: [], // 设备信息
      filtersForm: {
        prodname: '',
        custname: '',
        start_end_date: [],
        start: '',
        end: '',
        page: 1,
        pagesize: 10,
        auth_code: '',
        device_serial: ''
      },
      pickerOptions: {
        shortcuts: [{
          text: '将来一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '将来一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '将来三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      registerDialogVisible: false,
      formType: "add",
      registerForm: {
        cust_id: "",
        prod_id: "",
        expire_time: "",
        amount: 1
      },
      registerFormRules: {
        cust_id: [{
          required: true,
          message: "请选择客户",
          trigger: "blur"
        }],
        prod_id: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        expire_time: [{
          required: true,
          message: "请选择失效时间",
          trigger: "blur"
        }],
        amount: [{
          required: true,
          message: "请输入数量，至少为1",
          trigger: "blur"
        }]
      },
      tableData: [],
      products: null,
      customers: null,
      subCustomers: [],
      sub_cust_id: "",
      loading: false,

      handleLoading: false,
      page: 1,
      pagesize: 10,
      total: 0
    };
  },
  methods: {
    showDeviceInfo(deviceSerial) {
      getDeviceInfo({ device_serial: deviceSerial }).then(res => {
        if (res.code == 200) {
          this.deviceInfo = res.data || {}
          this.deviceInfoList = (res.data && res.data.detail) || []
          this.deviceModal = true
        } else {
          this.$message.error(res.message)
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "服务器错误，请联系系统管理员！"
        });
      })
    },
    handleDelete(id) {
      this.$confirm("此操作将删除该授权, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteAuthority(id)
            .then(res => {
              if (res.code == 201) {
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.getAuthorityList();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(res => {
              this.$message({
                type: "info",
                message: "服务器问题，请联系系统管理员！"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    cusIdChange(v) {
      let cur = this.customers.find(item => {
        return v === item.cust_id
      });
      this.subCustomers = cur.subcusts || []
      this.sub_cust_id = this.subCustomers.length > 0 ? this.subCustomers[0].cust_id : ""
    },
    handleAdd() {
      this.formType = "add";
      this.registerDialogVisible = true;
      if (this.products && this.customers) return;

      this.handleLoading = true;
      getCustProdcut().then(res => {
        this.handleLoading = false;
        if (res.code == 200) {
          this.products = res.data.prods;
          this.customers = res.data.custs;
          this.subCustomers = [];
        }
      }).catch(res => {
        this.handleLoading = false;
        this.$message({
          message: "服务器错误，请联系系统管理员！",
          type: "error"
        });
      })
    },
    async handleUpdate(row) {
      this.formType = "edit";
      this.registerDialogVisible = true;
      this.registerForm = { ...row };
      if (!this.products || !this.customers) {
        this.handleLoading = true;
        try {
          const res = await getCustProdcut()
          if (res.code == 200) {
            this.products = res.data.prods;
            this.customers = res.data.custs;
          }
        } catch (err) {
          this.$message({
            message: "服务器错误，请联系系统管理员！",
            type: "error"
          });
        }
        this.handleLoading = false;
      };

      this.subCustomers = [];
      this.sub_cust_id = "";
      parentLoop:
      for (let idx = 0; idx < this.customers.length; idx++) {
        const item = this.customers[idx];
        if (item.cust_id == row.cust_id) {
          break;
        }
        let sub_custs = item.subcusts;
        if (sub_custs) {
          for (let j = 0; j < sub_custs.length; j++) {
            const element = sub_custs[j];
            if (element.cust_id == row.cust_id) {
              this.subCustomers = sub_custs;
              this.registerForm.cust_id = item.cust_id;
              this.sub_cust_id = element.cust_id;
              break parentLoop;
            }
          }
        }
      }
    },
    handleUnBind(id) {
      this.$confirm("此操作将解绑该授权, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          unbindAuthority(id)
            .then(res => {
              if (res.code == 201) {
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.getAuthorityList();
              } else {
                this.$message({
                  type: 'warning',
                  message: res.message
                });
              }
            })
            .catch(res => {
              this.$message({
                type: "info",
                message: "服务器问题，请联系系统管理员！"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //该方法暂时未用
    handleEdit(item) {
      this.handleAdd();
      this.registerForm = {
        auth_code: item.auth_code,
        cust_id: item.cust_id,
        prod_id: item.prod_id,
        expire_time: item.expire_time,
        amount: item.amount,
        auth_code: item.auth_code
      }
      this.registerDialogVisible = true;
    },
    resetRegisterForm() {
      this.$refs['registerForm'].resetFields();
      this.registerForm = {
        cust_id: "",
        prod_id: "",
        expire_time: "",
        amount: 1,
        auth_code: ''
      }

      this.registerDialogVisible = false;
    },
    handleSubmit() {
      this.$refs["registerForm"].validate(valid => {
        if (valid) {
          var date = new Date(this.registerForm.expire_time).toLocaleDateString();
          this.registerForm.expire_time = date;
          this.sub_cust_id && (this.registerForm.cust_id = this.sub_cust_id);
          this.handleLoading = true;
          if (this.registerForm.auth_code) {
            updateAuthority(this.registerForm).then(res => {
              if (res.code == 201) {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.getAuthorityList();
                this.resetRegisterForm();
              } else {
                this.$message.error(res.message);
              }
              this.handleLoading = false;
            });
          } else {
            addAuthority(this.registerForm).then(res => {
              if (res.code == 201) {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.getAuthorityList();
                this.resetRegisterForm();
              } else {
                this.$message.error(res.message);
              }
              this.handleLoading = false;
            });
          }
        } else {
          this.$message({
            message: "存在必填项未填",
            type: "success"
          });
        }
      });
    },
    getAuthorityList(page) {
      this.loading = true;
      if (page) {
        this.filtersForm.page = page;
      }
      if (this.filtersForm.start_end_date && this.filtersForm.start_end_date.length != 0) {
        this.filtersForm.start = this.filtersForm.start_end_date[0];
        this.filtersForm.end = this.filtersForm.start_end_date[1];
      } else {
        this.filtersForm.start = null;
        this.filtersForm.end = null;
      }
      getAuthorityList(this.filtersForm).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.total;
        }

      }).catch(res => {
        this.loading = false;
        this.$message({
          message: "服务器错误，请联系系统管理员！",
          type: "error"
        });
      })
    }
  },
  mounted() {
    this.getAuthorityList();
  }
};

</script>

<style>
.info-title {
  text-align: right;
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/authorization/index.vue